/*============================================================================
  Cotton drawstring (CDS) add-on
  - Product page: optional CDS picker (snippets/product-cds-option.liquid).
    When selected, the bag and the CDS are added to the cart in one request,
    linked by a hidden `_cds_link` line item property.
  - Cart guard: products listed in the "Add-on products" theme setting can't
    stay in the cart without their bag. Orphan add-on lines are removed and
    their quantity follows the bag's quantity.
==============================================================================*/
(function() {
  var LINK_PROPERTY = '_cds_link';
  var addonIds = (window.theme && theme.addonOnlyProductIds) || [];

  function getOption(form) {
    // form.id would return the form's `name="id"` variant input
    var formId = form && form.getAttribute && form.getAttribute('id');
    if (!formId) return null;
    return document.querySelector('[data-cds-option][data-form-id="' + formId + '"]');
  }

  function selectedCdsVariant(option) {
    var toggle = option.querySelector('[data-cds-toggle]');
    if (!toggle || !toggle.checked) return null;
    var radio = option.querySelector('[data-cds-variant]:checked');
    return radio ? radio.value : null;
  }

  /*----------------------------------------------------------------------------
    Product page
  ----------------------------------------------------------------------------*/
  function formatMoney(cents) {
    return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
  }

  // Closest ancestor holding the theme's price, i.e. the product container
  function getPriceContainer(option) {
    var el = option.parentElement;
    while (el && !el.querySelector('[data-product-price]')) {
      el = el.parentElement;
    }
    return el;
  }

  // Shows bag price + CDS price while the add-on is selected. The theme rewrites
  // the price on every bag variant change, so this runs again after it.
  function updatePrice(option, form) {
    var container = getPriceContainer(option);
    var bagInput = form && form.querySelector('[name="id"]');
    if (!container || !bagInput) return;

    var bagPrices = JSON.parse(option.dataset.bagPrices)[bagInput.value];
    if (!bagPrices) return;

    var radio = option.querySelector('[data-cds-variant]:checked');
    var extra = selectedCdsVariant(option) && radio ? parseInt(radio.dataset.price, 10) : 0;

    var price = container.querySelector('[data-product-price]');
    price.innerHTML = formatMoney(bagPrices[0] + extra);

    var comparePrice = container.querySelector('[data-compare-price]');
    if (comparePrice && bagPrices[1] > bagPrices[0]) {
      comparePrice.innerHTML = formatMoney(bagPrices[1] + extra);
    }
  }

  function initOption(option) {
    var toggle = option.querySelector('[data-cds-toggle]');
    var variants = option.querySelector('[data-cds-variants]');
    var form = document.getElementById(option.dataset.formId);

    toggle.addEventListener('change', function() {
      variants.hidden = !toggle.checked;

      // Dynamic checkout buttons (Shop Pay, Buy it now...) skip the cart and
      // would only buy the bag, so hide them while the add-on is selected
      if (form) {
        form.querySelectorAll('.shopify-payment-button').forEach(function(el) {
          el.hidden = toggle.checked;
        });
      }

      updatePrice(option, form);
    });

    variants.addEventListener('change', function() {
      updatePrice(option, form);
    });

    document.addEventListener('variant:change', function() {
      setTimeout(function() { updatePrice(option, form); });
    });
  }

  function buildBagItem(form) {
    var data = new FormData(form);
    var item = {
      id: data.get('id'),
      quantity: parseInt(data.get('quantity'), 10) || 1,
      properties: {}
    };

    data.forEach(function(value, key) {
      var match = key.match(/^properties\[(.+)\]$/);
      if (match && typeof value === 'string') {
        item.properties[match[1]] = value;
      }
    });

    if (data.get('selling_plan')) {
      item.selling_plan = data.get('selling_plan');
    }

    return item;
  }

  function showError(form, message) {
    var errors = form.querySelector('.errors');
    if (errors) errors.remove();

    var errorDiv = document.createElement('div');
    errorDiv.classList.add('errors', 'text-center');
    errorDiv.textContent = message;
    form.append(errorDiv);

    form.dispatchEvent(new CustomEvent('ajaxProduct:error', {
      detail: { errorMessage: message },
      bubbles: true
    }));
  }

  // Runs in the capture phase, before theme.AjaxProduct's submit listener
  function onSubmit(evt) {
    var form = evt.target;

    // Add-on only products can't be bought from their own page
    if (form.querySelector && form.querySelector('[data-addon-only]')) {
      evt.preventDefault();
      evt.stopImmediatePropagation();
      return;
    }

    var option = getOption(form);
    if (!option) return;

    var cdsVariantId = selectedCdsVariant(option);
    if (!cdsVariantId) return;

    evt.preventDefault();
    evt.stopImmediatePropagation();

    var button = form.querySelector('[data-add-to-cart]');
    if (button) {
      if (button.classList.contains('btn--loading')) return;
      button.classList.add('btn--loading');
    }

    var link = Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
    var bag = buildBagItem(form);
    bag.properties[LINK_PROPERTY] = link;

    var cds = {
      id: cdsVariantId,
      quantity: bag.quantity,
      properties: {}
    };
    cds.properties[LINK_PROPERTY] = link;

    fetch(theme.routes.cartAdd, {
      method: 'POST',
      body: JSON.stringify({ items: [bag, cds] }),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      }
    })
    .then(function(response) { return response.json(); })
    .then(function(data) {
      if (button) button.classList.remove('btn--loading');

      if (data.status === 422 || data.status === 'bad_request') {
        showError(form, data.description || data.message);
        return;
      }

      var errors = form.querySelector('.errors');
      if (errors) errors.remove();

      if (theme.settings.cartType === 'page') {
        window.location = theme.routes.cartPage;
        return;
      }

      if (document.body.classList.contains('template-cart')) {
        window.scrollTo(0, 0);
        location.reload();
        return;
      }

      form.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: { product: data, addToCartBtn: button },
        bubbles: true
      }));
    })
    .catch(function(error) {
      if (button) button.classList.remove('btn--loading');
      console.error(error);
    });
  }

  /*----------------------------------------------------------------------------
    Cart guard
  ----------------------------------------------------------------------------*/
  function isAddon(item) {
    return addonIds.indexOf(item.product_id) !== -1;
  }

  function getUpdates(cart) {
    var updates = {};
    var hasUpdates = false;

    cart.items.forEach(function(item) {
      if (!isAddon(item)) return;

      var link = item.properties && item.properties[LINK_PROPERTY];
      var bag = link && cart.items.find(function(other) {
        return !isAddon(other) && other.properties && other.properties[LINK_PROPERTY] === link;
      });
      var quantity = bag ? bag.quantity : 0;

      if (item.quantity !== quantity) {
        updates[item.key] = quantity;
        hasUpdates = true;
      }
    });

    return hasUpdates ? updates : null;
  }

  function syncCart(cart) {
    if (!cart || !cart.items) return;

    var updates = getUpdates(cart);
    if (!updates) return;

    fetch('/cart/update.js', {
      method: 'POST',
      body: JSON.stringify({ updates: updates }),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      }
    })
    .then(function() {
      document.dispatchEvent(new CustomEvent('cart:build'));
    })
    .catch(function(error) { console.error(error); });
  }

  // The legacy "with / without cotton drawstring bag" option is hidden when the
  // add-on is offered. Old links (?variant=) may still preselect "with".
  // Values are translated, so the "without" value comes from the Liquid.
  function selectLegacyWithout(wrapper) {
    var inputs = Array.prototype.slice.call(wrapper.querySelectorAll('[data-variant-input]'));
    var without = inputs.find(function(input) { return input.value === wrapper.dataset.withoutValue; });
    if (without && !without.checked) {
      without.click();
    }
  }

  function init() {
    document.querySelectorAll('[data-cds-legacy-option]').forEach(selectLegacyWithout);
    document.querySelectorAll('[data-cds-option]').forEach(initOption);
    document.addEventListener('submit', onSubmit, true);

    if (!addonIds.length) return;

    document.addEventListener('cart:updated', function(evt) {
      syncCart(evt.detail && evt.detail.cart);
    });

    if (theme.cartHasAddonOnly) {
      fetch(''.concat(theme.routes.cart, '?t=').concat(Date.now()), { credentials: 'same-origin' })
        .then(function(response) { return response.json(); })
        .then(syncCart)
        .catch(function(error) { console.error(error); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
